/**
 * Canonical SDK field projection for the `/launchpad` proposal-feed surface
 * (FQ-097). Lives in a plain (non-`'use client'`) module with NO server-only
 * imports so it can be safely consumed from BOTH:
 *
 *   - the client component (`components/launchpad/proposal-feed.tsx`) for the
 *     `useGetProposalsInfinite` call, and
 *   - the SSR prefetch helper (`lib/sdk/ssr/launchpad-listing.ts`) — which
 *     pulls in `next/headers` via `getServerNetworkConfig` and cannot be
 *     imported from client code.
 *
 * Both call sites MUST use the same array reference so the SSR-dehydrated
 * cache key matches the client's hook args byte-for-byte (otherwise the
 * client misses the hydrated cache and re-renders `isPending` on first paint).
 */

/** Element type — every field the launchpad proposal-feed grid projects. */
export type LaunchpadFeedField =
  | 'marketType'
  | 'partnerCreatorId'
  | 'associatedCreator'
  | 'pubkey'
  | 'proposalId'
  | 'title'
  | 'description'
  | 'category'
  | 'location'
  | 'status'
  | 'totalFunded'
  | 'totalStaked'
  | 'marketConfig'
  | 'creationThresholdPct'
  | 'backerCount'
  | 'numBackers'
  | 'coverImageUrl'
  | 'coverImageNsfw'
  | 'numOutcomes'
  | 'debateSpreadOk'
  | 'graduatedMarketPubkey'
  | 'createdAt'
  | 'updatedAt'
  | 'expiresAt'
  | 'upvotes'
  | 'downvotes'
  | 'netVotes'
  | 'myVote'
  | 'proposalScore'
  | 'outcomes'
  | 'proposer'
  | 'topBackers';

export const LAUNCHPAD_FEED_FIELDS: readonly LaunchpadFeedField[] = [
  'marketType',
  'partnerCreatorId',
  'associatedCreator',
  'pubkey',
  'proposalId',
  'title',
  'description',
  'category',
  'location',
  'status',
  'totalFunded',
  'totalStaked',
  'marketConfig',
  'creationThresholdPct',
  'backerCount',
  'numBackers',
  'coverImageUrl',
  'coverImageNsfw',
  'numOutcomes',
  'debateSpreadOk',
  'graduatedMarketPubkey',
  'createdAt',
  'updatedAt',
  'expiresAt',
  'upvotes',
  'downvotes',
  'netVotes',
  'myVote',
  'proposalScore',
  'outcomes',
  'proposer',
  'topBackers',
];
